import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background":"linear-gradient(251.83deg, #111D60 2.89%, #334295 89.62%)"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "order-2 order-md-1 mt-4" }, [
        _createElementVNode("span", { class: "text-white fw-bold me-1" }, "Copyright ©"),
        _createElementVNode("a", {
          href: "https://www.chainedesrotisseurs.com/",
          target: "_blank",
          class: "text-white"
        }, "La Chaîne des Rôtisseurs")
      ], -1))
    ])
  ]))
}